import { Context, Getters } from 'vuex-smart-module';
import { Store } from 'vuex';

import { IModuleSettings, Poll } from '../types';

import AppStore from '@/store/appstore';
import PollsState from './state';

export default class PollsGetters extends Getters<PollsState> {
  app!: Context<typeof AppStore>;

  $init(store: Store<typeof AppStore>): void {
    this.app = AppStore.context(store);
  }

  get settings(): IModuleSettings {
    const settings =
      this.app.state.appData.settings?.modules?.polls || ({} as IModuleSettings);

    settings.list = settings.list ?? [];
    settings.reminderProfileEdit = settings.reminderProfileEdit ?? true;
    settings.showRegistrationPollReminder = settings.showRegistrationPollReminder ?? true;

    return settings;
  }

  get polls(): Poll[] {
    return this.getters.settings.list;
  }
}
